import { render, staticRenderFns } from "./send.vue?vue&type=template&id=79e73fda&scoped=true&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"
import style0 from "./send.vue?vue&type=style&index=0&id=79e73fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e73fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e73fda')) {
      api.createRecord('79e73fda', component.options)
    } else {
      api.reload('79e73fda', component.options)
    }
    module.hot.accept("./send.vue?vue&type=template&id=79e73fda&scoped=true&", function () {
      api.rerender('79e73fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rule/ruleSend/send.vue"
export default component.exports